import { api } from "./_client";

export async function listPlugins() {
    const { data } = await api.get("/plugins");
    return data.plugins || [];
}

export async function setProjectPlugins(projectId, activeIds) {
    const { data } = await api.put(`/projects/${projectId}/plugins`, {
        active_ids: activeIds,
    });
    return data.active_ids || [];
}

// ----- Plugin presets (iter-171): named plugin combos per user -----

export async function listPluginPresets() {
    const { data } = await api.get("/plugin-presets");
    return data.presets || [];
}

export async function createPluginPreset({ name, plugin_ids = [], workgroup_id = null }) {
    const { data } = await api.post("/plugin-presets", {
        name,
        plugin_ids,
        workgroup_id,
    });
    return data.preset;
}

export async function deletePluginPreset(presetId) {
    const { data } = await api.delete(`/plugin-presets/${presetId}`);
    return data;
}

// ----- Plugin custom prompts (iter-43) -----

export async function listPluginPrompts({
    pluginId = null,
    kind = null,
    includeShared = false,
} = {}) {
    const params = {};
    if (pluginId) params.plugin_id = pluginId;
    if (kind) params.kind = kind;
    if (includeShared) params.include_shared = true;
    const { data } = await api.get("/plugins/custom-prompts", { params });
    return data.prompts || [];
}

export async function createPluginPrompt({
    plugin_id,
    kind,
    title,
    body,
    input_type = "button",
    placeholder = "",
    options = [],
}) {
    const { data } = await api.post("/plugins/custom-prompts", {
        plugin_id,
        kind,
        title,
        body,
        input_type,
        placeholder,
        options,
    });
    return data.prompt;
}

export async function updatePluginPrompt(promptId, patch = {}) {
    const { data } = await api.patch(
        `/plugins/custom-prompts/${promptId}`,
        patch,
    );
    return data.prompt;
}

export async function deletePluginPrompt(promptId) {
    const { data } = await api.delete(`/plugins/custom-prompts/${promptId}`);
    return data;
}

// ----- Plugin catalog CRUD (superadmin, iter-45) -----

export async function createPlugin(payload) {
    const { data } = await api.post("/plugins", payload);
    return data.plugin;
}

export async function updatePlugin(pluginId, patch) {
    const { data } = await api.patch(`/plugins/${pluginId}`, patch);
    return data.plugin;
}

export async function deletePlugin(pluginId) {
    const { data } = await api.delete(`/plugins/${pluginId}`);
    return data;
}

export async function uploadPluginIcon(pluginId, file) {
    const form = new FormData();
    form.append("file", file);
    const { data } = await api.post(`/plugins/${pluginId}/icon`, form, {
        headers: { "Content-Type": "multipart/form-data" },
    });
    return data.plugin;
}
// iter-47 — admin-view (includes master prompts) + PATCH master prompts

export async function getPluginAdmin(pluginId) {
    const { data } = await api.get(`/plugins/${pluginId}/admin`);
    return data.plugin;
}

export async function updateMasterPrompts(pluginId, patch) {
    const { data } = await api.patch(
        `/plugins/${pluginId}/master-prompts`,
        patch,
    );
    return data.plugin;
}
// iter-48 — superadmin dev preview of the composed plugin fragment.

export async function previewPluginFragment({
    kind,
    plugin_ids = [],
    plugin_prompt_ids = [],
    plugin_adhoc_prompts = [],
    plugin_prompt_inputs = {},
}) {
    const { data } = await api.post("/plugins/preview-fragment", {
        kind,
        plugin_ids,
        plugin_prompt_ids,
        plugin_adhoc_prompts,
        plugin_prompt_inputs,
    });
    return data; // { fragment, kind, active_plugin_ids }
}

// ----- Superadmin dashboard (iter-42) -----
